import React, { useEffect, useState } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import PreApprovalLetter from "../../../components/loan_tools/forms/pre_approval_letter";
import FormEmailButton from "../../../components/loan_tools/forms/form_email_button";
import { useDocument } from "../../../components/loan_tools/loan_tool";
import { downloadElementAsPdf } from "../../../constants/download_pdf";

export default function PreApprovalLetterRoute() {
  const [loanDoc, , , actions] = useDocument();
  const [pdfBusy, setPdfBusy] = useState(false);

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName ? `${lastName} – Pre-Approval Letter` : "Pre-Approval Letter";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  async function downloadPdf() {
    setPdfBusy(true);
    try {
      const borrowers =
        loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
      const lastName =
        (borrowers && borrowers[0] && borrowers[0].last_name) || "Pre-Approval";
      await downloadElementAsPdf(
        window.document.querySelector(".pq-doc"),
        `${lastName} Pre-Approval Letter.pdf`,
        { fit: "page" }
      );
    } catch (e) {
      window.alert(
        "Sorry — couldn't generate the PDF. You can still use Print and choose “Save as PDF.”"
      );
    } finally {
      setPdfBusy(false);
    }
  }

  return (
    <StandardTemplate className="ba-template">
      <div className="ba-page-actions no-print">
        <button className="button" onClick={() => window.print()}>Print</button>
        <button className="button" onClick={downloadPdf} disabled={pdfBusy}>
          {pdfBusy ? "Generating PDF…" : "Download PDF"}
        </button>
        <FormEmailButton docName="Pre-Approval Letter" />
      </div>
      <PreApprovalLetter />
    </StandardTemplate>
  );
}
